import { render, staticRenderFns } from "./contentsView.vue?vue&type=template&id=120f8646&scoped=true"
import script from "./contentsView.vue?vue&type=script&lang=js"
export * from "./contentsView.vue?vue&type=script&lang=js"
import style0 from "./contentsView.vue?vue&type=style&index=0&id=120f8646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f8646",
  null
  
)

export default component.exports